<template>
  <div class="flex flex-col space-y-4 pb-4">
    <div class="flex items-center space-x-3 bg-gray-100 rounded-lg px-5 py-4">
      <img
        :src="`/static/integrations/${provider.name}.png`"
        class="rounded-full"
        width="30px"
        height="30px"
      />
      <span class="font-poppins text-base font-semibold">
        {{ provider.name }}
      </span>
    </div>
    <div>To create a <span class="underline">course from</span> {{ provider.name }}:</div>
    <ul>
      <li class="mb-2">
        1. Ensure you have a premium school account.
        <span class="text-primary underline cursor-pointer" @click="upgrade">
          Upgrade here
        </span>
        if you have a school code.
      </li>
      <li class="mb-2">
        2. Ensure your school IT Admin has approved the connection between
        Parlay and {{ provider.name }}.
      </li>
      <li>
        3. Connect your Parlay account to your
        {{ provider.name }} account inside
        <span
          class="text-primary underline cursor-pointer"
          @click="connectProfile"
        >
          your profile
        </span>
        .
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    props: {
      provider: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {};
    },
    computed: {},
    methods: {
      upgrade() {
        this.$emit('close');
        this.$router.push({
          name: 'profile.membership',
        });
      },
      connectProfile() {
        this.$emit('close');
        this.$router.push({
          name: 'profile.integrations',
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// instructionsToCreateCourseFromLms.vue?3c821806